import { useCallback, useEffect, useState } from "react";
import CaseTable from "../caseStudy/CaseTable";
import { Link } from "react-router-dom";
import "./case_category.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

// const CaseCategoryDeleteEndpoint = ApiEndpoints.caseCategory.caseCategoryDelete;
const caseCategoryListEndpoint = ApiEndpoints.caseCategory.caseCategoryList;
const caseEditPath = "edit-case-category";
const tableHeader = ["Title",];
const tbody = ["name",];

export default function CaseCategoryList() {

  const [data, setData] = useState([]);

  const dataFetch = useCallback(
    async () => {
      try {
        const response = await ApiRequest("GET", caseCategoryListEndpoint);
        const result = response.casestudy_categories;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    },[caseCategoryListEndpoint]);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);
  
  return (
    <>
      <div className="header-add-category">
        <h5>Case Category</h5>
      </div>
      <div className="add-mediacat-section">
        <Link className="default-btn" to="/admin/add-case-category">
          Add Case Category
        </Link>
        <CaseTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={caseEditPath}
          // onDelete={handleDelete}
        />
      </div>
    </>
  )
}
